import { queryClient } from '#/lib/init';
import AppStateStore from '#/stores/AppStateStore';
import { ReservationRewardPointsStatus } from '@jucy/rentals-api-client/rentals-api-v3/models/ReservationRewardPointsStatus';
import { autorun, makeAutoObservable, runInAction } from 'mobx';

export class RewardPointsStore {
    config?: ReservationRewardPointsStatus = undefined;
    appStateStore: AppStateStore;
    isLoading = false;

    constructor(initialData?: Partial<RewardPointsStore>) {
        makeAutoObservable(this);
        Object.assign(this, initialData);

        autorun(async () => {
            this.refreshRewardPoints();
        });
    }

    async refreshRewardPoints() {
        try {
            const reservationRef = this.appStateStore?.selectedReservationRef;
            if (!reservationRef || !this.appStateStore?.authStore?.selfServiceApiClient?.v3.getReservationRewardPointsStatus) {
                return;
            }

            runInAction(() => {
                this.isLoading = true;
            });
            const config = await queryClient.fetchQuery({
                queryKey: ['rewardPoints', 'config', reservationRef],
                queryFn: () => this.appStateStore.authStore?.selfServiceApiClient?.v3.getReservationRewardPointsStatus(reservationRef),
            });
            runInAction(() => {
                this.config = config;
            });
        } finally {
            runInAction(() => {
                this.isLoading = false;
            });
        }
    }
}
